import { ConnectedPage } from './connected-page';
import { ConstantsModule } from './../constants/constants.module';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

export class ConnectedPageWithTable extends ConnectedPage {
	// Classe gerant le tableau.
	public columns: any[] = [];
	public datas: any[] = [];
	public first = 0;
	public rows = 10;

	constructor(constantsModule: ConstantsModule, cookieService: CookieService, httpClient: HttpClient, router: Router, modalService: NgbModal) {
		super(constantsModule, cookieService, httpClient, router, modalService);
	}

	public setColumns(columns:any[]): void {
		// Prepare the columns of the table.
		this.columns = columns;
	}

	public setData(data:[]): void {
		// Load directly the table.
		this.datas = data;
	}

	public getData(): any[] {
		return this.datas;
	}

	public getDataItem(index: any): any {
		return this.datas[index];
	}

	public addData(newItem: Object): void {
		// Add a new item and do a sort.
		this.datas.push(newItem);
		this.datas = [ ...this.datas];
	}

	public filterData(): void {
		// Force filtering after modifying data.
		this.datas = [ ...this.datas];
	}

	public loadData(url: string): void {
		// Load directly the data from the database.
		this.put(url, undefined,
			(data) => {
				if (data.DATA == "ERR") {
					switch (data.VALUE) {
						case "UNAUTHORIZED":
							this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits pour accéder à ces données.";
							break;
						case "DATABASE":
								this.alertLine.alertDangerMessage = "Impossible de se connecter à la base de données. Contactez votre administrateur.";
							break;
						default:
							this.alertLine.alertDangerMessage = "Erreur inconnue (" + data.VALUE + "). Contactez votre administrateur.";
							break;
					}
				} else {
					// Setting the data.
					this.datas = data.RES;
				}
			},
			(err) => {
				// Cannot load the data.
				this.alertLine.alertDangerMessage = "Impossible de se connecter au serveur (Erreur: " + this.httpErrorToText(err) + ").";
			}
		);
	}

	public resetData(): void {
		// Clear the full data.
		this.datas = [];
	}

	public hasEmptyList(): boolean {
		// Returns if the list of the table is empty or has not been filled.
		if (this.datas === []) return true;
		return this.datas.length == 0;
	}

	public next(): void {
		// Set to the next page.
		this.first = this.first + this.rows;
	}

	public prev(): void {
		// Set to the previous page.
		this.first = this.first - this.rows;
	}

	public reset(): void {
		// Go to the first page.
		this.first = 0;
	}

	public isLastPage(): boolean {
		// Test if the displayed page is the last one.
		return this.datas ? (this.datas.length - this.first) < this.rows : true;
	}

	public isFirstPage(): boolean {
		// Test if the displayed page is the first one.
		return this.datas ? this.first === 0 : true;
	}
}
